module.exports = __webpack_public_path__ + "de77a722/img/trash-icon.ff8201c7.svg";